// The context bag an engine primitive expects (passContexts): page contexts, then the embedding component's
// scoped entity contexts, then the element's own, each as { entityType, pk, appName? }. currentUser is the
// engine's own (the destination's publication user that app rows point at), not the page's platform user.
function pkIsComplete(pk) {
  return Boolean(pk) && typeof pk === "object" && Object.keys(pk).length > 0
    && Object.values(pk).every(value => value !== null && value !== undefined && value !== "");
}

export function mergeEngineContexts(pageContexts, scopedContexts, ownContexts, { currentUserPk = null } = {}) {
  const scoped = {};
  Object.entries(scopedContexts ?? {}).forEach(([name, entry]) => {
    if (!entry || typeof entry !== "object" || !entry.entityType || !pkIsComplete(entry.entityPkUrlVars)) {
      return;
    }
    scoped[name] = { entityType: entry.entityType, pk: entry.entityPkUrlVars };
    if (entry.appName) {
      scoped[name].appName = entry.appName;
    }
  });
  const merged = { ...pageContexts, ...scoped, ...ownContexts };
  if (pkIsComplete(currentUserPk)) {
    merged.currentUser = { entityType: "User", pk: currentUserPk };
  }
  return merged;
}
